<script setup lang="ts">
import ToolbarButton from "@/components/TipTapEditor/ToolbarButton.vue";
import { useDialog } from "@/utils/dialog";
import { Editor, BubbleMenu, isActive } from "@tiptap/vue-3";

const { openConfirm } = useDialog();
const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    editor: typeof Editor;
  }>(),
  {}
);

const removeTable = async () => {
  if (await openConfirm(t("website.deleteTable"), t("buttons.delete"))) {
    props.editor.chain().focus().deleteTable().run();
  }
};
// because editor.state is not updated at the moment shouldShow is getting called, the editor.isActive doesn’t work as expected. As a workaround we use the underlying isActive method
// where you can pass a newer state.
// @ts-ignore: TODO: FixMe
const shouldShowTableBubbleMenu = ({ state }) => {
  return isActive(state, "table");
};
</script>
<template>
  <BubbleMenu
    :style="{ marginTop: '10px', fontWeight: '100' }"
    class="wysiwyg-bubble-menu"
    :tippy-options="{ duration: 100 }"
    :editor="editor"
    :should-show="shouldShowTableBubbleMenu"
    plugin-key="table-bubble-menu"
  >
    <ToolbarButton @click="editor.chain().focus().addColumnBefore().run()">
      <i class="bi">
        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M13,2A2,2 0 0,0 11,4V20A2,2 0 0,0 13,22H22V2H13M20,10V14H13V10H20M20,16V20H13V16H20M20,4V8H13V4H20M9,11H6V8H4V11H1V13H4V16H6V13H9V11Z"
          />
        </svg>
      </i>
    </ToolbarButton>
    <ToolbarButton @click="editor.chain().focus().addColumnAfter().run()">
      <i class="bi">
        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M11,2A2,2 0 0,1 13,4V20A2,2 0 0,1 11,22H2V2H11M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M15,11H18V8H20V11H23V13H20V16H18V13H15V11Z"
          />
        </svg>
      </i>
    </ToolbarButton>
    <ToolbarButton @click="editor.chain().focus().deleteColumn().run()">
      <i class="bi">
        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M4,2H11A2,2 0 0,1 13,4V20A2,2 0 0,1 11,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M17.59,12L15,9.41L16.41,8L19,10.59L21.59,8L23,9.41L20.41,12L23,14.59L21.59,16L19,13.41L16.41,16L15,14.59L17.59,12Z"
          />
        </svg>
      </i>
    </ToolbarButton>

    <span class="wysiwyg-toolbar__separator"></span>

    <ToolbarButton @click="editor.chain().focus().addRowBefore().run()">
      <i class="bi">
        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M22,14A2,2 0 0,0 20,12H4A2,2 0 0,0 2,14V21H4V19H8V21H10V19H14V21H16V19H20V21H22V14M4,14H8V17H4V14M10,14H14V17H10V14M20,14V17H16V14H20M11,10H13V7H16V5H13V2H11V5H8V7H11V10Z"
          />
        </svg>
      </i>
    </ToolbarButton>
    <ToolbarButton @click="editor.chain().focus().addRowAfter().run()">
      <i class="bi">
        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M22,10A2,2 0 0,1 20,12H4A2,2 0 0,1 2,10V3H4V5H8V3H10V5H14V3H16V5H20V3H22V10M4,10H8V7H4V10M10,10H14V7H10V10M20,10V7H16V10H20M11,14H13V17H16V19H13V22H11V19H8V17H11V14Z"
          />
        </svg>
      </i>
    </ToolbarButton>
    <ToolbarButton @click="editor.chain().focus().deleteRow().run()">
      <i class="bi">
        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M9.41,13L12,15.59L14.59,13L16,14.41L13.41,17L16,19.59L14.59,21L12,18.41L9.41,21L8,19.59L10.59,17L8,14.41L9.41,13M22,9A2,2 0 0,1 20,11H4A2,2 0 0,1 2,9V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V9M4,9H8V6H4V9M10,9H14V6H10V9M16,9H20V6H16V9Z"
          />
        </svg>
      </i>
    </ToolbarButton>

    <span class="wysiwyg-toolbar__separator"></span>

    <ToolbarButton @click="removeTable">
      <i class="bi bi-trash"> </i>
    </ToolbarButton>
  </BubbleMenu>
</template>
